import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { EmailVerificationComponent } from './email-verification.component';
import { EmailVerificationService }   from './email-verification.service';
import { SharedModule }               from '../shared/shared.module';

@NgModule({
  declarations: [
    EmailVerificationComponent
  ],
  entryComponents: [
    EmailVerificationComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    EmailVerificationService
  ],
  schemas: [NO_ERRORS_SCHEMA] })
export class EmailVerificationModule {}